// =============================================================================
// MeuDriver — Batch O4: useAdminPayouts
// KPIs financeiros do painel de pagamentos do admin.
// =============================================================================

import { useQuery } from '@tanstack/react-query'
import { supabase } from '@/lib/supabase'

// ---------------------------------------------------------------------------
// Tipos
// ---------------------------------------------------------------------------

export interface FinancialSummary {
  total_gmv: number
  total_commission: number
  total_paid_out: number
  pending_payouts: number
  platform_balance: number
}

// ---------------------------------------------------------------------------
// Query keys
// ---------------------------------------------------------------------------

const adminPayoutKeys = {
  all: ['admin-payouts'] as const,
  summary: () => [...adminPayoutKeys.all, 'summary'] as const,
}

// ---------------------------------------------------------------------------
// useAdminFinancialSummary — KPIs financeiros via RPC admin_get_financial_summary
// ---------------------------------------------------------------------------

export function useAdminFinancialSummary() {
  return useQuery<FinancialSummary>({
    queryKey: adminPayoutKeys.summary(),
    staleTime: 1000 * 60 * 5,
    queryFn: async () => {
      const { data, error } = await supabase.rpc('admin_get_financial_summary')
      if (error) throw new Error(error.message)

      // RPC retorna array de uma linha
      const row = Array.isArray(data) ? data[0] : data
      return {
        total_gmv: Number(row?.total_gmv ?? 0),
        total_commission: Number(row?.total_commission ?? 0),
        total_paid_out: Number(row?.total_paid_out ?? 0),
        pending_payouts: Number(row?.pending_payouts ?? 0),
        platform_balance: Number(row?.platform_balance ?? 0),
      }
    },
  })
}
